export const SET_REPORT_MILESTONES = "SET_REPORT_MILESTONES";
export const GET_REPORT_MILESTONES = "GET_REPORT_MILESTONES";
export const REFRESH_REPORT_MILESTONES = "GET_REPORT_MILESTONES";